import {
    Sidebar,
    SidebarContent, SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem
} from "@always_faithful/shadcn/components/ui/sidebar"
import {Link} from '@tanstack/react-router'

const items = [
    {
        title: "Home",
        url: "/",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M6.133 21C4.955 21 4 20.02 4 18.81v-8.802c0-.665.295-1.295.8-1.71l5.867-4.818a2.09 2.09 0 0 1 2.666 0l5.866 4.818c.506.415.801 1.045.801 1.71v8.802c0 1.21-.955 2.19-2.133 2.19z'/>
                <path d='M9.5 21v-5.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2V21'/>
            </svg>,
    },
    {
        title: "Новини",
        url: "/blog",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M5 20.25c0 .414.336.75.75.75h10.652C17.565 21 18 20.635 18 19.4v-1.445M5 20.25A2.25 2.25 0 0 1 7.25 18h10.152q.339 0 .598-.045M5 20.25V6.2c0-1.136-.072-2.389 1.092-2.982C6.52 3 7.08 3 8.2 3h9.2c1.236 0 1.6.437 1.6 1.6v11.8c0 .995-.282 1.425-1 1.555'/>
            </svg>,
    },
    {
        title: "Вакансії",
        url: "/vacancies",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M7.805 3.469C8.16 3.115 8.451 3 8.937 3h6.126c.486 0 .778.115 1.132.469l4.336 4.336c.354.354.469.646.469 1.132v6.126c0 .5-.125.788-.469 1.132l-4.336 4.336c-.354.354-.646.469-1.132.469H8.937c-.5 0-.788-.125-1.132-.469L3.47 16.195c-.355-.355-.47-.646-.47-1.132V8.937c0-.5.125-.788.469-1.132z'/>
                <path d='M13.856 13.85a3.429 3.429 0 1 0-4.855-4.842 3.429 3.429 0 0 0 4.855 4.842m0 0L16 16'/>
            </svg>,
    },
    {
        title: "Про нас",
        url: "/about",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M17 19.5c0-1.657-2.239-3-5-3s-5 1.343-5 3m14-3c0-1.23-1.234-2.287-3-2.75M3 16.5c0-1.23 1.234-2.287 3-2.75m12-4.014a3 3 0 1 0-4-4.472M6 9.736a3 3 0 0 1 4-4.472m2 8.236a3 3 0 1 1 0-6 3 3 0 0 1 0 6'/>
            </svg>,
    },
    {
        title: "Контакти",
        url: "/contacts",
        icon:
            <svg width="34" height="34" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M2.36 7.708v6.989c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.31c.642.328 1.482.328 3.162.328h9.68c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V7.708m-19.28 0 7.308-4.062c.851-.473 1.277-.71 1.727-.802a3 3 0 0 1 1.21 0c.45.093.876.33 1.727.802l7.308 4.062m-19.28 0 6.978 4.655c.962.641 1.442.962 1.963 1.087.46.11.939.11 1.398 0 .52-.125 1.002-.446 1.965-1.088l6.976-4.654'/>
            </svg>,
    },
    {
        title: "Увійти",
        url: "/login",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M13.496 21H6.5c-1.105 0-2-1.151-2-2.571V5.57c0-1.419.895-2.57 2-2.57h7'/>
                <path d='M13 15.5 9.5 12 13 8.5m6.5 3.496h-10'/>
            </svg>,
    },
    {
        title: "Реєстрація",
        url: "/register",
        icon:
            <svg width="30" height="30" fill="none" stroke="#A5A897" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M5 20.25c0 .414.336.75.75.75h10.652C17.565 21 18 20.635 18 19.4v-1.445M5 20.25A2.25 2.25 0 0 1 7.25 18h10.152q.339 0 .598-.045M5 20.25V6.2c0-1.136-.072-2.389 1.092-2.982C6.52 3 7.08 3 8.2 3h9.2c1.236 0 1.6.437 1.6 1.6v11.8c0 .995-.282 1.425-1 1.555'/><path d='M15 14c0-3.861-6-3.861-6 0'/>
                <path d='M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/>
            </svg>,
    },
]

function AppSidebar() {
    return(
        <Sidebar>
            <SidebarContent className="bg-white/30 backdrop-blur-sm text-white p-4">
                <SidebarGroup>
                    <SidebarGroupLabel className="font-noto-sans-mono text-xl">Завжди вірний</SidebarGroupLabel>
                    <hr className="my-4" />
                    <SidebarGroupContent>
                        <SidebarMenu className="space-y-3">
                            {items.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton asChild>
                                        <div>
                                            <Link to={item.url} className="flex gap-4">
                                                {item.icon}
                                                <span className="text-lg">{item.title}</span>
                                            </Link>
                                        </div>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                    <SidebarFooter>
                    </SidebarFooter>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    )
}
export default AppSidebar;